import { useLoadedData } from '../../toolympus/hooks/useLoadedData';
import { ProjectStage } from './types';
import { useListItemActions } from '../../toolympus/hooks/useListItemActions';

export const ProjectStageApiPath = "/api/project/stage";

export const useProjectStages = (projectId: number) => {
  const { data: initialStages, reload, isLoading } = useLoadedData<ProjectStage[]>(
    `${ProjectStageApiPath}?project_id=${projectId}`,
    [],
    !!projectId && projectId > 0,
  );

  const x = useListItemActions<ProjectStage>({
    getRecordApiPath: r => r ? `${ProjectStageApiPath}/${r._id}` : `${ProjectStageApiPath}`,
    newRecordDefault: { project_id: projectId, title: "", state: "inprogress" },
    onAnySave: () => reload(),
    removeMemoTrigger: reload,
  })

  return {
    isLoading: isLoading,
    stages: initialStages,
    ...x,
  };
};
